import { ApplicationFormValues } from '../../../../LoanDetailTypes';
import { Ruleset } from '../../interfaces/Ruleset';
import {
  HasApplicantFiledTR,
  RulesetResult,
  IsBusinessEstablishedMoreThan,
  IsExpressLoan,
  IsForProfit,
  IsBetweenMidFebMidApril,
  IsBetweenMidAugMidOct,
  IsBetweenMidMayMidAug,
  IsBetweenMidAprilMidMay,
  IsBetweenJanAndMidFeb,
  HasApplicantFiledTRLastYear,
} from '../rules';

class TR3YearsAgoRuleset implements Ruleset {
  public evaluate = (data: Partial<ApplicationFormValues>): RulesetResult => {
    const isForProfit = IsForProfit.evaluate(data);
    const isExpress = IsExpressLoan.evaluate(data);
    const isEstablishedMoreThan3YearsAgo =
      IsBusinessEstablishedMoreThan.setYears(3).evaluate(data);
    const isBetweenJanAndMidApril = [
      IsBetweenJanAndMidFeb,
      IsBetweenMidFebMidApril,
    ].some((Is) => Is.evaluate(data));
    const isBetweenMidAprilAndMidOct = [
      IsBetweenMidAprilMidMay,
      IsBetweenMidMayMidAug,
      IsBetweenMidAugMidOct,
    ].some((Is) => Is.evaluate(data));
    const hasApplicantFiledTRLastYear =
      HasApplicantFiledTRLastYear.evaluate(data);

    // A) If For Profit && Not Express:
    // - Established More Than 3 Years Ago? REQUIRED : OPTIONAL
    // B) If For Profit && Express:
    // - Between Jan and Mid April && Established More Than 3 Years Ago? REQUIRED : OPTIONAL
    // - Between Mid April and Mid Oct ?:
    //  - Filed TR Last Year? HIDDEN : if No, REQUIRED
    //  - Else if NOT Established More Than 3 Years Ago? OPTIONAL
    // If Not For Profit && Filed TR In The Past:
    // - Established More Than 3 Years Ago? REQUIRED : OPTIONAL

    // B) If For Profit && Express:
    if (isForProfit && isExpress) {
      // - Between Jan and Mid April:
      //   - Established More Than 3 Years Ago? REQUIRED : OPTIONAL
      if (isBetweenJanAndMidApril) {
        return isEstablishedMoreThan3YearsAgo
          ? RulesetResult.REQUIRED
          : RulesetResult.OPTIONAL;
      }

      // - Between Mid April and Mid Oct:
      //   - Filed TR Last Year? HIDDEN
      //   - Else if NOT Established More Than 3 Years Ago? OPTIONAL
      //   - Else REQUIRED
      if (isBetweenMidAprilAndMidOct) {
        if (hasApplicantFiledTRLastYear) return RulesetResult.HIDDEN;
        if (!isEstablishedMoreThan3YearsAgo) return RulesetResult.OPTIONAL;
        return RulesetResult.REQUIRED;
      }

      return RulesetResult.HIDDEN;
    }

    if (isForProfit && !isExpress) {
      return isEstablishedMoreThan3YearsAgo
        ? RulesetResult.REQUIRED
        : RulesetResult.OPTIONAL;
    }

    if (isForProfit && isExpress) {
      if (isBetweenJanAndMidApril) {
        return isEstablishedMoreThan3YearsAgo
          ? RulesetResult.REQUIRED
          : RulesetResult.OPTIONAL;
      }

      if (isBetweenMidAprilAndMidOct) {
        if (hasApplicantFiledTRLastYear) return RulesetResult.HIDDEN;
        if (isEstablishedMoreThan3YearsAgo && !hasApplicantFiledTRLastYear)
          return RulesetResult.REQUIRED;
        return RulesetResult.OPTIONAL;
      }

      return RulesetResult.HIDDEN;
    }

    // If Not For Profit && Filed TR In The Past:
    // - Established More Than 3 Years Ago? REQUIRED : OPTIONAL
    if (!isForProfit && HasApplicantFiledTR.evaluate(data)) {
      return isEstablishedMoreThan3YearsAgo
        ? RulesetResult.REQUIRED
        : RulesetResult.OPTIONAL;
    }
    return RulesetResult.HIDDEN;
  };
}

export default new TR3YearsAgoRuleset();
